import React, { useState } from "react";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../DashboardLeftMenu";
import { FIELD_TYPES } from "./component/FieldTypes";
import { getDefaultField } from "./utils/formUtils";
import FormFieldEditor from "./component/FormFieldEditor";
import FormPreview from "./component/FormPreview";
import { faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FormBuilder = ({ onSave }) => {
    const [fields, setFields] = useState([]);
    const [editingFieldId, setEditingFieldId] = useState(null);

    const addField = (type) => {
        const newField = getDefaultField(type);
        setFields((s) => [...s, newField]);
    };

    const updateField = (id, updates) => setFields((s) => s.map((f) => (f.id === id ? { ...f, ...updates } : f)));

    const removeField = (id) => {
        setFields((s) => s.filter((f) => f.id !== id));
        if (editingFieldId === id) setEditingFieldId(null);
    };

    const saveForm = (type) => {
        // Create form JSON structure
        const formData = {
            id: Date.now(), // unique form id
            createdAt: new Date().toISOString(),
            fields: fields.map(field => ({
                id: field.id,
                type: field.type,
                name: field.name || '',
                label: field.label || '',
                placeholder: field.placeholder || '',
                helperText: field.helperText || '',
                required: !!field.required,
                width: field.width || 'full',
                options: field.options || [],
                // Add any other field properties you want to save
            }))
        };

        localStorage.setItem('formData', JSON.stringify(formData));
        console.log('Form JSON:', formData); // For debugging
        if (type === 'Preview') {
            window.open('/dashboard/form/view/123221', '_blank');
        } else {
            alert('Form saved successfully!');
        }
        onSave && onSave(formData);
    };

    const editingField = fields.find((f) => f.id === editingFieldId);

    const panelHeaderStyle = {
        padding: "12px 16px",
        borderBottom: "1px solid #eee",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    };

    return (
        <>
            <div className="wrapper">
                <DashboardLeftMenu />
                <div className="main">
                    <DashboardHeader />
                    <main className="content">


                        <div className="row justify-content-center">
                            <div className="col-md-4">

                                <div className="card" style={{ position: "relative" }}>
                                    {editingFieldId ?
                                        <div aria-hidden={!editingFieldId}>
                                            <div style={panelHeaderStyle}>
                                                <strong>Field Settings</strong>
                                                <div>
                                                    <button className="btn btn-sm btn-outline-primary me-2" onClick={() => setEditingFieldId(null)}>
                                                        <FontAwesomeIcon icon={faPlus} /> New Input
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-danger me-2"
                                                        type="button"
                                                        onClick={() => {
                                                            if (editingFieldId) {
                                                                removeField(editingFieldId);
                                                                setEditingFieldId(null);
                                                            }
                                                        }}
                                                        disabled={!editingFieldId}
                                                        aria-label="Remove selected field"
                                                    >
                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                    </button>
                                                    <button className="btn btn-sm btn-primary" onClick={() => setEditingFieldId(null)}>
                                                        Done
                                                    </button>
                                                </div>
                                            </div>

                                            <div style={{ padding: 16, overflowY: "auto", flex: 1 }}>
                                                {editingField ? (
                                                    <>
                                                        <FormFieldEditor
                                                            field={editingField}
                                                            onChange={updateField}
                                                            onRemove={(id) => {
                                                                removeField(id);
                                                                setEditingFieldId(null);
                                                            }}
                                                        />
                                                        <div className="mt-3">
                                                            <small className="text-muted">Tip: change "Width" or toggle "Required" inside the editor.</small>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="text-center text-muted">Select a field to edit</div>
                                                )}
                                            </div>
                                        </div>
                                        :

                                        <div className="">
                                            <div style={panelHeaderStyle}>
                                                <strong>Choose input fields</strong>
                                            </div>

                                            <div className="p-2 d-flex flex-wrap">
                                                {FIELD_TYPES.filter(t => t.category !== 'advance').map((t) => (
                                                    <button
                                                        key={t.type}
                                                        className="btn-sm btn-bg-black d-flex align-items-center"
                                                        onClick={() => addField(t.type)}
                                                        type="button"
                                                        aria-label={`Add ${t.label}`}
                                                    >
                                                        <span aria-hidden="true" style={{ display: "inline-flex", alignItems: "center" }}>
                                                            {t.icon}
                                                        </span>
                                                        <span className="ms-2">Add {t.label}</span>
                                                    </button>
                                                ))}
                                            </div>

                                            { /* Render advance fields under their own header if any exist */}
                                            {FIELD_TYPES.some(t => t.category === 'advance') && (
                                                <>
                                                    <div style={panelHeaderStyle}>
                                                        <strong>Advance input fields</strong>
                                                    </div>
                                                    <div className="mb-3 p-2 d-flex w-100 flex-wrap">
                                                        {FIELD_TYPES.filter(t => t.category === 'advance').map((t) => (
                                                            <button
                                                                key={t.type}
                                                                className="btn-sm btn-bg-black-advance w-100 d-flex align-items-center"
                                                                onClick={() => addField(t.type)}
                                                                type="button"
                                                                aria-label={`Add ${t.label}`}
                                                            >
                                                                <span aria-hidden="true" style={{ display: "inline-flex", alignItems: "center" }}>
                                                                    {t.icon}
                                                                </span>
                                                                <span className="ms-2">Add {t.label}</span>
                                                            </button>
                                                        ))}
                                                    </div>
                                                </>
                                            )}

                                        </div>
                                    }
                                </div>

                            </div>

                            <div className="col-md-8">
                                <div className="card">
                                    <div style={panelHeaderStyle}>
                                        <strong className="">Form Preview</strong>
                                        <div className="d-flex">
                                            <button onClick={() => saveForm('Preview')} className="btn btn-sm btn-outline-info me-2">
                                                Preview
                                            </button>

                                            <button className="btn btn-sm btn-info ms-auto" onClick={() => saveForm('Save')}>
                                                Save
                                            </button>
                                            <button className="btn btn-sm btn-primary ms-auto" onClick={() => saveForm('publish')}>
                                                Publish
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <FormPreview fields={fields} onEditField={(id) => setEditingFieldId(id)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <DashboardFooter />
                </div>
            </div>
        </>
    );
};

export default FormBuilder;